module.exports = __webpack_public_path__ + "static/media/plus image.3dff302b.jpeg";